import config from '../../../assets/js/conf/config';
import md5 from 'js-md5';
import { sendMessageData, regUserData, loginData, forgotData1, forgotData2, updatePasswordData, getUserInfoData, getUserAvatarData, updateUserInfoData, setCollectionData, getCollectionData, updateUserIdCardData, setGoodsVerifyCode, setGoodsCreateOrder, getGoodsOrderList, getAchieveData, setReceiveAchieveData } from "../../../api/user";

let modules = {
  namespaced: true,
  state: {

    userInfo: localStorage['userInfo'] ? JSON.parse(localStorage['userInfo']) : "",
    guid: localStorage['guid'] ? localStorage['guid'] : "",
    security: localStorage['security'] ? localStorage['security'] : "",
    isLogin: localStorage['isLogin'] ? Boolean(localStorage['isLogin']) : false,

    favs: [],
    goodsTimeSort:0,
    goodList:[],
    achieveList:[],

  },
  mutations: {

    ["SET_LOGIN"](state, payload) {

      state.userInfo = payload.userInfo;
      state.guid = payload.userInfo.guid;
      state.security = payload.userInfo.security;
      state.isLogin = payload.isLogin;

      localStorage["userInfo"] = JSON.stringify(payload.userInfo);
      localStorage["guid"] = payload.userInfo.guid;
      localStorage["security"] = payload.userInfo.security;
      localStorage["isLogin"] = payload.isLogin;


    },
    ["OUT_LOGIN"](state) {

      console.log('OUT_LOGIN')

      state.userInfo = "";
      state.guid = "";
      state.isLogin = false;
      state.security = "";
      state.goodList = [];


      localStorage.removeItem("userInfo");
      localStorage.removeItem("guid");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("security");

    },
    ["SET_USER_INFO"](state, payload) {
      state.userInfo = payload.userInfo;
      state.security = payload.userInfo.security;
      localStorage["userInfo"] = JSON.stringify(payload.userInfo);
      localStorage["security"] = payload.userInfo.security;
    },



    // 设置收藏
    // ["SET_COLLECTION"](state,payload){
    //     // state.details.is_collection=payload.type;
    //     // if(payload.type === 1){
    //     //     state.details.collection_num = parseInt(state.details.collection_num)+1;
    //     // } else {
    //     //     state.details.collection_num = parseInt(state.details.collection_num)-1;
    //     // }

    // }, 


    //设置我的收藏
    ["GET_FAVS"](state, payload) {
      state.favs = payload.favs;
    },
    ["SET_FAVS_PAGE"](state, payload) {
      state.favs.push(...payload.favs);
    },
    //删除收藏
    ["DEL_FAVS"](state, payload) {
      state.favs.splice(payload.index, 1);
    },

    // 获取藏品列表
    ["GET_GOODS_ORDER"](state, payload) {
      state.goodList = payload.goodList;
      state.goodsTimeSort = payload.goodsTimeSort;
    },

    // 获取藏品列表
    ["GET_ACHIEVE"](state, payload) {
      state.achieveList = payload.data;
    },



    

  },
  actions: {

    //获取验证码
    sendMessage(conText, payload) {

      let serial_number = sessionStorage.getItem("serial_number");

      let username = payload.username;
      let datetime = Date.parse(new Date()) / 1000;
      let username_send_message = config.sendMessage;
      let ver = "1.0.11";
      let token = md5(md5(serial_number + "&" + username + "&" + datetime + "&" + ver) +"&" +username_send_message);
      let data = {
        serial_number: serial_number,
        username: username,
        datetime: datetime,
        token: token,
        ver: ver,
      };
      sendMessageData(JSON.stringify(data)).then(res => {
        if (payload.success) {
          payload.success(res)
        }
      })
      
    },

    // 注册
    regUser(conText, payload) {
      let data = JSON.stringify(payload.data);
      regUserData(data).then(res => {
        if (res.status == 1) {
          conText.commit("SET_LOGIN", { userInfo: res.user, isLogin: true });
        }
        if (payload.success) {
          payload.success(res);
        }
      })
    },

    // 登录
    login(conText, payload) {
      let data = JSON.stringify(payload.data);
      loginData(data).then(res => {
        if (res.status == 1) {
          conText.commit("SET_LOGIN", { userInfo: res.user, isLogin: true });
        }
        if (payload.success) {
          payload.success(res);
        }
      })

      
      // loginData2({auid:'a123456'}).then(res => {
      //   console.log(res);

      //   // if (payload.success) {
      //   //   payload.success(res);
      //   // }
      // })
    },

    // 修改密码
    updatePassword(conText, payload) {



      
      let guid = conText.state.guid;
      let security = conText.state.security;

      let password = payload.data.password;
      let confirmPassword = payload.data.confirmPassword;
      let code = payload.data.code;

      let username_pass_key = config.passKey;
      let token = md5(md5(guid + "|" + security + "|" + password) +"|" +username_pass_key);
      
      let data = {
        guid,
        security,
        token,
        password,
        confirmPassword,
        code,
      };
      updatePasswordData(JSON.stringify(data)).then(res => {
        if (payload.success) {
          payload.success(res);
        }
      })


    },
    // 忘记密码1        
    forgotPassword1(conText, payload) {
      let serial_number = sessionStorage.getItem("serial_number");
      let username = payload.data.username;
      let code = payload.data.code;
      let forgot_time = Date.parse(new Date()) / 1000;
      let ver = "1.0.11";
      let username_pass_key = config.passKey;
      let token = md5(md5(username + '|' + ver + '|' + serial_number + '|' + forgot_time) + '|' + username_pass_key);
      let data = {
        serial_number,
        username,
        forgot_time,
        code,
        token,
        ver,
      }
      forgotData1(JSON.stringify(data)).then(res => {
        // console.log(res);
        if (payload.success) {
          payload.success(res);
        }
      })
    },
    // 忘记密码1        
    forgotPassword2(conText, payload) {

      let username_pass_key = config.passKey;
      let token = md5(md5(payload.data.guid + '|' + payload.data.security + '|' + payload.data.password) + '|' + username_pass_key)
      let data = {
        ...payload.data,
        token,
      }
      forgotData2(JSON.stringify(data)).then(res => {
        // console.log(res);
        if (payload.success) {
          payload.success(res);
        }
      })
    },


    //获取会员信息
    getUserInfo(conText, payload) {
      

      let guid = conText.state.guid;
      let security = conText.state.security;      
      let username_pass_key = config.passKey;
      let token = md5(md5(guid + '|' + security) + '|' + username_pass_key);      
      let data = {
        guid, security, token 
      };
      getUserInfoData(JSON.stringify(data)).then(res => {
        if (payload && payload.success) {
          payload.success(res);
        }
      })

    },

    //安全退出
    outLogin(conText, payload) {

      conText.commit("OUT_LOGIN");
      if (payload.success) {
        payload.success()
      }

    },

    //获取头像列表
    getUserAvatar(conText, payload) {
      
      let guid = conText.state.guid;
      let security = conText.state.security;      
      let username_pass_key = config.passKey;
      let token = md5(md5(guid + '|' + security) + '|' + username_pass_key);      
      let data = {
        guid, security, token
      };
      getUserAvatarData(JSON.stringify(data)).then(res => {
        if (payload && payload.success) {
          payload.success(res);
        }
      })
    },

    //修改会员信息
    updateUserInfo(conText, payload) {

      let guid = conText.state.guid;
      let security = conText.state.security;      
      let username_pass_key = config.passKey;
      let token = md5(md5(guid + '|' + security) + '|' + username_pass_key);
      
      let avatar = conText.state.userInfo.avatar;
      let nickname = '';
      
      let sex = conText.state.userInfo.sex;
      let signature = conText.state.userInfo.signature;

      if(payload.avatar){
        avatar = payload.avatar;
      }
      if(conText.state.userInfo.chknickname){
        if(conText.state.userInfo.chknickname !== payload.nickname){
          nickname = payload.nickname;
        }
      } else {
        if(conText.state.userInfo.nickname !== payload.nickname){
          nickname = payload.nickname;
        }
      }

      if(payload.sex){
        sex = payload.sex;
      }      
      // console.log(conText.state.userInfo);
      // console.log(payload.nickname);
      // console.log(payload);
      
      let data = {
        guid,
        security,
        token,
        nickname,
        avatar,
        sex,
        signature
      };

      // console.log(data)
      
      updateUserInfoData(JSON.stringify(data)).then(res => {
        if (payload.success) {
          payload.success(res);
        }

      })


    },

    //修改个人简介
    updateUserInfoSignature(conText, payload) {


      let guid = conText.state.guid;
      let security = conText.state.security;      
      let username_pass_key = config.passKey;
      let token = md5(md5(guid + '|' + security) + '|' + username_pass_key);
      
      let avatar = conText.state.userInfo.avatar;
      let nickname = '';      
      let sex = conText.state.userInfo.sex;
      let signature = payload.signature;
      
      let data = {
        guid,
        security,
        token,
        nickname,
        avatar,
        sex,
        signature
      };

      // console.log(data)
      
      updateUserInfoData(JSON.stringify(data)).then(res => {
        if (payload.success) {
          payload.success(res);
        }

      })


    },

    //修改会员信息
    updateUserIdCard(conText, payload) {


      let guid = conText.state.guid;
      let security = conText.state.security;      
      let username_pass_key = config.passKey;
      let token = md5(md5(guid + '|' + security) + '|' + username_pass_key);      
      let truename = payload.name;
      let idcard = payload.idcard;            
      let data = {
        guid,
        security,
        token,        
        truename,
        idcard,
      };
      updateUserIdCardData(JSON.stringify(data)).then(res => {
        if (payload.success) {
          payload.success(res);
        }
      })


    },


    
    // updateUserInfo(conText, payload) {
    //
    //   let data = JSON.stringify(payload.data);
    //   updateUserInfoData(data).then(res => {
    //     if (payload.success) {
    //       payload.success(res);
    //     }
    //   })
    // },


    updateUserAvatar(conText, payload) {
      let avatar = payload.avatar;
      let guid = conText.state.guid;
      let security = conText.state.security;      
      let username_pass_key = config.passKey;
      let token = md5(md5(guid + '|' + security) + '|' + username_pass_key);
      let nickname = '';
      let sex = conText.state.userInfo.sex;
      let signature = conText.state.userInfo.signature;
      let data = {
        guid,
        security,
        token,
        nickname,
        avatar,
        sex,
        signature
      };
      updateUserInfoData(JSON.stringify(data)).then(res => {
        if (payload.success) {
          payload.success(res);
        }
      })

    },


    // 我的收藏
    getCollection(conText, payload) {

      // console.log(res)

      let sendMessage = config.sendMessage;
      let security = conText.state.security;
      // let username_pass_key = config.passKey;

      let guid = conText.state.guid;
      let token = md5(md5(guid + '|' + security) + '|' + sendMessage);
      let data = {
        guid,
        security,
        token,
      }

      // console.log(data)            
      getCollectionData(JSON.stringify(data)).then(res => {
        // console.log(res)

        if (res.status == 1) {
          conText.commit("GET_FAVS", { favs: res.data });
        }
        if (payload.success) {
          payload.success(res);
        }
      })

    },

    // 设置收藏
    setCollection(conText, payload) {

      // console.log(res)
      let productKey = config.productKey;
      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;

      let id = payload.id;
      let type = payload.type;  // 1收藏  0取消收藏

      // console.log(security);
      // console.log(guid);

      let token = md5(md5(guid + '|' + security + '|' + id + '|' + type) + '|' + productKey);

      let data = {
        security,
        guid,
        token,
        type,
        id
      }
      setCollectionData(JSON.stringify(data)).then(res => {
        // console.log(res)
        if (res.status == 1) {
          // conText.commit("SET_COLLECTION",{type:type});

        }
        if (payload.success) {
          payload.success(res);
        }
      })

    },

    // 验证兑换码
    setGoodsVerifyCode(conText, payload) {

      let productKey = config.productKey;
      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;
      let code = payload.code;
      let token = md5(md5(guid + '|' + security + '|' + code) + '|' + productKey);
      let data = {
        security,
        guid,
        token,
        code
      }
      setGoodsVerifyCode(JSON.stringify(data)).then(res => {
        // console.log(res)
        if (payload.success) {
          payload.success(res);
        }
      })

    },
    // 兑换码订单
    setGoodsCreateOrder(conText, payload) {

      let productKey = config.productKey;
      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;
      let province = payload.province;
      let areaid = payload.areaid;
      let code = payload.code;
      let token = md5(md5(guid + '|' + security + '|' + code + '|' + province) + '|' + productKey);
      let data = {
        security,
        guid,
        token,
        province,
        areaid,
        code
      }

      // console.log(data);
      
      setGoodsCreateOrder(JSON.stringify(data)).then(res => {
        // console.log(res)
        if (payload.success) {
          payload.success(res);
        }

      })

    },
    // 兑换码订单
    getGoodsOrderList(conText, payload) {
      
      let goodsTimeSort = payload.goodsTimeSort;

      let productKey = config.productKey;
      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;
      let token = md5(md5(guid + '|' + security) + '|' + productKey);
      let data = {
        security,
        guid,
        token
      }
      getGoodsOrderList(JSON.stringify(data)).then(res => {
        // console.log(res)
        if (res.status == 1) {
          // this.getGoodsSort(1111);
          let goodList = res.data.order;
          if(goodsTimeSort === 1){
            goodList = goodList.reverse();
          }
          conText.commit("GET_GOODS_ORDER", { goodList: goodList,goodsTimeSort:goodsTimeSort });

        }
        if (payload.success) {
          payload.success(res);
        }

      })

    },


    getGoodsOrderSort(conText, payload) {
      let goodsTimeSort = payload.goodsTimeSort;
      let goodList = conText.state.goodList;
      goodList = goodList.reverse();
      conText.commit("GET_GOODS_ORDER", { goodList: goodList,goodsTimeSort:goodsTimeSort });
      if (payload.success) {
        payload.success(goodsTimeSort);
      }
    },
    
    // 我的成就
    getAchieveList(conText, payload) {
      

      let sendMessage = config.sendMessage;
      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;
      let token = md5(md5(guid + '|' + security) + '|' + sendMessage);


      let data = {
        security,
        guid,
        token
      }
      getAchieveData(JSON.stringify(data)).then(res => {
        // console.log(res)
        if (res.status == 1) {
          let achieveList = [];
          for(let i in res.data){
            achieveList.push(res.data[i])
          }
          conText.commit("GET_ACHIEVE", { data: achieveList });
        }
        if (payload.success) {
          payload.success(res);
        }

      })

    },

    // 领取成就
    setReceiveAchieve(conText, payload) {      

      let camp_id = payload.camp_id;
      let sendMessage = config.sendMessage;
      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;
      let token = md5(md5(guid + '|' + security) + '|' + sendMessage);

      let data = {
        security,
        guid,
        token,
        camp_id
      }
      setReceiveAchieveData(JSON.stringify(data)).then(res => {
        // console.log(res)
        if (res.status == 1) {
          conText.commit("GET_ACHIEVE", { data: res.data });
        }
        if (payload.success) {
          payload.success(res);
        }

      })

    },
    


    





    //----------------


    //上传头像
    uploadHead(conText, payload) {
      uploadHeadData(payload).then(res => {
        if (payload.success) {
          payload.success(res);
        }
      })
    },

    //修改手机号
    updateCellphone(conText, payload) {
      updateCellphoneData({ uid: conText.state.uid, ...payload }).then(res => {
        if (payload.success) {
          payload.success(res);
        }
      })
    },



    //我的收藏
    // getFav(conText,payload){
    //     getFavData({uid:conText.state.uid,...payload}).then(res=>{
    //         let pageNum=0;
    //         if(res.code===200){
    //             conText.commit("SET_FAVS",{favs:res.data});
    //             pageNum=res.pageinfo.pagenum;
    //         }else{
    //             conText.commit("SET_FAVS",{favs:[]});
    //             pageNum=0;
    //         }
    //         if(payload.success){
    //             payload.success(pageNum);
    //         }
    //     })
    // },
    // getFavPage(conText,payload){
    //     getFavData({uid:conText.state.uid,...payload}).then(res=>{
    //         if(res.code===200){
    //             conText.commit("SET_FAVS_PAGE",{favs:res.data});
    //             if(payload.success){
    //                 payload.success()
    //             }
    //         }
    //     })
    // },
    // //删除收藏
    // delFav(conText,payload){
    //     delFavData({uid:conText.state.uid,...payload}).then(res=>{
    //         if(res.code===200){
    //             conText.commit("DEL_FAVS",{index:payload.index});
    //             if(payload.success){
    //                 payload.success();
    //             }
    //         }
    //     });
    // }


  }

}
export default modules;